module.exports = __webpack_public_path__ + "img/7.91b05661.jpg";